// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-small-text-eb51b978"};